import React from "react";
import Box from "@mui/material/Box";
import Projectcolors from "../Utils/Colors";
import { baseURL } from "../Config/config";
import { Typography, Link, DialogContent } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import OutlinedInput from "@mui/material/OutlinedInput";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Alert from "@mui/material/Alert";
import { makeStyles } from "@mui/styles";
import GlobalLoader from "./CommonC/GlobalLoader";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Checkbox, CircularProgress } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import DeleteIcon from "@mui/icons-material/Delete";
import model from "../images/model.png";
import SearchIcon from "@mui/icons-material/Search";
import { AppBar, Tab, Tabs } from '@mui/material';



export default function FirstPrinciples(props) {
  const [fp, setfp] = React.useState([
    [
      ["123445", "Reflux Ratio()", "", ""],
      ["12348798", "Reflux Ratio()", "", ""],
      ["12348798", "Reflux Ratio()", "", ""],
    ],
    [
      ["123445", "Reflux Ratio()", "", "", null],
      ["123445", "Reflux Ratio()", "", "", null],
    ],
  ]);

  const [addfprow, setaddfprow] = React.useState([
    [false, false, false],
    [false, false],
  ]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [getvalues, setgetValues] = React.useState([]);
  const [falsewarning, setfalsewarning] = React.useState(false);

  const [getLoader, setGetLoader] = React.useState(false);
  const [isChecked, setIsChecked] = React.useState(false);
  const [saved, setSaved] = React.useState(false);
  const [isPopupOpen, setPopupOpen] = React.useState(false);
  const [info, setinfo] = React.useState(false);
  const [selectedTab, setSelectedTab] = React.useState(0);
  const [formula, setFormula] = React.useState("");
  const [formind, setFormind] = React.useState(0);


  function addfpin() {
    const fpcopy = Array.from(fp);
    const addfprowcopy = Array.from(addfprow);
    fpcopy[0].push(["", "", "", ""]);
    addfprowcopy[0].push(true);
    setaddfprow(addfprowcopy);
    setfp(fpcopy);
  }

  const handleMagnifyClick = (formulaa,i) => {
    setFormula(formulaa)
    setFormind(i)
    setPopupOpen(true);
  };

  const handleInfoClick = () => {
    setinfo(true);
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
  };
  const handleCloseinfo = () => {
    setinfo(false);
  };
  

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  function savefp() {
    const ProjectID = sessionStorage.getItem("projectID");
    var save = false;
    for (var i = 0; i < fp[0].length; i++) {
      if (fp[0][i][2] == "") {
        setfalsewarning(true);
        save = true;
      }
    }
    for (var i = 0; i < fp[1].length; i++) {
      if (fp[1][i][2] == "") {
        setfalsewarning(true);
        save = true;
      }
    }

    if (save == false) {
      setIsLoading(true);
      try {
        fetch(`${baseURL}/savefp`, {
          method: "POST",
          body: JSON.stringify({
            fp: fp,
            fprow: addfprow,
            ProjectID: ProjectID,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((result) => {
            setIsLoading(false);
            setSaved(true);
            //props.handleNextStep();
          })
          .catch((error) => {
            setIsLoading(false);
            console.error("Error:", error);
          });
      } catch (error) {
        setIsLoading(false);
        console.log("Error", error);
      }
    }
  }
  function addfpde() {
    const fpcopy = Array.from(fp);
    fpcopy[1].push(["", "", "", "", ""]);
    setfp(fpcopy);
    const addfprowcopy = Array.from(addfprow);
    addfprowcopy[1].push(true);
    setaddfprow(addfprowcopy);
  }

  const handleDeclaInp = (event, idx, j) => {
    if (j == "ind_kpi") {
      const fpcopy = Array.from(fp);
      fpcopy[0][idx][0] = event.target.value;
      setfp(fpcopy);
    }
    if (j == "ind_desc") {
      const fpcopy = Array.from(fp);
      fpcopy[0][idx][1] = event.target.value;
      setfp(fpcopy);
    }
    if (j == "ind_declaration") {
      const fpcopy = Array.from(fp);
      fpcopy[0][idx][2] = event.target.value;
      setfp(fpcopy);
    }
    if (j == "ind_remark") {
      const fpcopy = Array.from(fp);
      fpcopy[0][idx][3] = event.target.value;
      setfp(fpcopy);
    }
    if (j == "dep_kpi") {
      const fpcopy = Array.from(fp);
      fpcopy[1][idx][0] = event.target.value;
      setfp(fpcopy);
    }
    if (j == "dep_desc") {
      const fpcopy = Array.from(fp);
      fpcopy[1][idx][1] = event.target.value;
      setfp(fpcopy);
    }
    if (j == "dep_declaration") {
      const fpcopy = Array.from(fp);
      fpcopy[1][idx][2] = event.target.value;
      setfp(fpcopy);
    }
    if (j == "dep_remark") {
      const fpcopy = Array.from(fp);
      fpcopy[1][idx][3] = event.target.value;
      setfp(fpcopy);
    }
    if (j == "dep_calculations") {
      const fpcopy = Array.from(fp);
      fpcopy[1][idx][4] = event.target.value;
      setfp(fpcopy);
      setFormula(event.target.value);
    }
  };
  console.log("fp[0]", fp[0]);
  console.log("fp[1]", fp[1]);
  console.log("addfprow", addfprow);

  React.useEffect(() => {
    getfpData();
  }, []);

  const getfpData = () => {
    setGetLoader(true);
    const projectID = sessionStorage.getItem("projectID");
    fetch(`${baseURL}/getfpData?projectID=${projectID}&loaded=${props.loaded}`)
      .then((res) => res.json())
      .then((data) => {
        console.log("response reveived");
        console.log("data", data);
        setfp(data.fp);
        setaddfprow(data.fprow);
        setGetLoader(false);
        if (data.saved == 1) {
          setgetValues(data.fp);
        }
        if (data.usefp == true) {
          setIsChecked(true);
        } else {
          setIsChecked(false);
        }
      })
      .catch((err) => {
        setGetLoader(false);
      });
  };

  function deleteSnap(x, idx) {
    console.log("deleteSnap", idx);
    const fpcopy = Array.from(fp);
    const addfprowcopy = Array.from(addfprow);
    fpcopy[x].splice(idx, 1);
    addfprowcopy[x].splice(idx, 1);
    setfp(fpcopy);
    setaddfprow(addfprowcopy);
  }
  const handlefalsewarningClose = () => {
    setfalsewarning(false);
  };

  const handlefpChange = (e) => {
    setIsChecked(e.target.checked);
    const ProjectID = sessionStorage.getItem("projectID");
    try {
      fetch(`${baseURL}/usefp`, {
        method: "POST",
        body: JSON.stringify({
          usefp: e.target.checked,
          ProjectID: ProjectID,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((result) => {
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.error("Error:", error);
        });
    } catch (error) {
      setIsLoading(false);
      console.log("Error", error);
    }
  };

  console.log("addfprow", addfprow);
  console.log("data", fp);
  const operatorsData = [
    { operator: '()', name: 'Brackets', example: '(a + b)/2' },
    { operator: '+', name: 'Addition', example: 'a + b' },
    { operator: '-', name: 'Subtraction', example: 'a - b' },
    { operator: '*', name: 'Multiplication', example: 'a * b' },
    { operator: '/', name: 'Division', example: 'a / b' },
    { operator: '%', name: 'Modulus', example: 'a % b' },
    { operator: '**', name: 'Exponentiation', example: 'a ** b' },
    { operator: '//', name: 'Floor Division', example: 'a // b' },
    // Add more operators as needed
  ];
  
  const functionsData = [
    { fnname: 'abs', name: 'Absolute Value', example: 'abs(x)' },
    { fnname: 'sqrt', name: 'Square Root', example: 'sqrt(x)' },
    { fnname: 'pow', name: 'Exponentiation', example: 'pow(x, y)' },
    { fnname: 'exp', name: 'Exponential', example: 'exp(x)' },
    { fnname: 'log', name: 'Logarithm', example: 'log(x, base)' },
    { fnname: 'sin', name: 'Sine', example: 'sin(x)' },
    { fnname: 'cos', name: 'Cosine', example: 'cos(x)' },
    { fnname: 'tan', name: 'Tangent', example: 'tan(x)' },
    { fnname: 'asin', name: 'Arcsine', example: 'asin(x)' },
    { fnname: 'acos', name: 'Arccosine', example: 'acos(x)' },
    { fnname: 'atan', name: 'Arctangent', example: 'atan(x)' },
    { fnname: 'floor', name: 'Floor', example: 'floor(x)' },
    { fnname: 'ceil', name: 'Ceiling', example: 'ceil(x)' },
    // Add more functions as needed
  ];
 
  const cardStyle = {
  borderRadius: "22px",
  border: "1px solid #0078c9",
  background: "linear-gradient(to bottom,#ffffff,#fbfcff)",
  boxShadow: "0 8px 25px rgba(0,120,201,.08)",
};
  const cardStyle2 = {
  borderRadius: "22px",
  border: "1px solid #d9e9f7",
  background: "linear-gradient(to bottom,#ffffff,#fbfcff)",
  boxShadow: "0 8px 25px rgba(0,120,201,.08)",
};

const sectionTitleStyle = {
  position: "absolute",
  top: -16,
  left: 20,
  px: 2,
  py: 0.8,
  borderRadius: "20px",
  background: "#0078c9",
  color: "#fff",
  fontWeight: 600,
  fontSize: 13,
  zIndex: 2,
};

const buttonStyle = {
  height: 36,
  fontSize: "12px",
  fontWeight: 600,
  borderRadius: "12px",
  textTransform: "none",
  background: "linear-gradient(90deg,#0078c9,#0d8fe6)",
  color: "#fff",
  "&:hover": {
    background: "#9e0b22",
  },
};

const inputStyle = {
  fontSize: "11px",
  minHeight: "30px",
  borderRadius: "10px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#0078c9",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#9e0b22",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#0078c9",
  },
};

const tableContainerStyle = {
  borderRadius: "16px",
  border: "1px solid #d9e9f7",
  boxShadow: "none",
  overflow: "auto",
};

const headCellStyle = {
  fontSize: "12px",
  color: "white",
  backgroundColor: Projectcolors.primary,
  fontWeight: 600,
};

const bodyCellStyle = {
  fontSize: "10px",
  height: 1,
  borderBottom: "1px solid #edf4fa",
};

 return (
  <Box sx={{ mt: 0 }}>
    <div className="popup">
      <Dialog open={info} onClose={handleCloseinfo} maxWidth="md" fullWidth>
        <DialogTitle sx={{ fontSize: "14px", color: Projectcolors.primary, fontWeight: 700 }}>
          Available Expressions and Functions
        </DialogTitle>

        <DialogContent sx={{ p: 2 }}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: "18px",
              border: "1px solid #d9e9f7",
              overflow: "hidden",
            }}
          >
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              TabIndicatorProps={{ style: { display: "none" } }}
              sx={{
                bgcolor: "#f8fafc",
                p: 1,
                "& .MuiTabs-flexContainer": { gap: 1 },
              }}
            >
              <Tab
                label="Mathematical Operators"
                value={0}
                sx={{
                  color: "#444",
                  fontSize: "12px",
                  textTransform: "capitalize",
                  borderRadius: "12px",
                  "&.Mui-selected": {
                    color: "#fff",
                    background: "linear-gradient(90deg,#0078c9,#0d8fe6)",
                  },
                }}
              />
              <Tab
                label="Mathematical Functions"
                value={1}
                sx={{
                  color: "#444",
                  fontSize: "12px",
                  textTransform: "capitalize",
                  borderRadius: "12px",
                  "&.Mui-selected": {
                    color: "#fff",
                    background: "linear-gradient(90deg,#0078c9,#0d8fe6)",
                  },
                }}
              />
            </Tabs>

            <Box sx={{ p: 2 }}>
              {selectedTab === 0 && (
                <div>
                  <table>
                    <tbody>
                      {operatorsData.map((item, index) => (
                        <tr key={index}>
                          <td style={{ padding: "10px", fontSize: "13PX" }}>{item.operator}</td>
                          <td style={{ padding: "10px", fontSize: "13PX" }}>{item.name}</td>
                          <td style={{ padding: "10px", fontSize: "13PX" }}>{item.example}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <hr />
                  <p style={{ fontSize: "13px", fontWeight: "bold" }}>Example :</p>
                  <p style={{ fontSize: "13px" }}>x1 = b + c</p>
                  <p style={{ fontSize: "13px" }}>x2 = ( b // c ) * x1</p>
                  <p style={{ fontSize: "13px" }}>x3= x1 + x2</p>
                </div>
              )}

              {selectedTab === 1 && (
                <div>
                  <table>
                    <tbody>
                      {functionsData.map((item, index) => (
                        <tr key={index}>
                          <td style={{ padding: "10px", fontSize: "13PX" }}>{item.fnname}</td>
                          <td style={{ padding: "10px", fontSize: "13PX" }}>{item.name}</td>
                          <td style={{ padding: "10px", fontSize: "13PX" }}>{item.example}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <hr />
                  <p style={{ fontSize: "13px", fontWeight: "bold" }}>Example :</p>
                  <p style={{ fontSize: "13px" }}> Y = log(x) + sin(x)</p>
                </div>
              )}
            </Box>
          </Paper>
        </DialogContent>
      </Dialog>
    </div>

    <Dialog
      open={falsewarning}
      onClose={handlefalsewarningClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{ color: "#9e0b22", fontSize: "13px", fontWeight: 600 }}
      >
        {"Declarations cannot be empty"}
      </DialogTitle>
    </Dialog>

    <Paper
      elevation={0}
      sx={{
        borderRadius: "18px",
        px: 2,
        py: 1,
        mb: 2,
        display: "flex",
        alignItems: "center",
        border: "1px solid #0078c9",
        boxShadow: "0 4px 18px rgba(0,0,0,.04)",
      }}
    >
      <Checkbox
        color="primary"
        inputProps={{ "aria-label": "select all desserts" }}
        sx={{
          color: "#9e0b22",
          "&.Mui-checked": {
            color: "#0078c9",
            borderColor: "#0078c9",
          },
        }}
        checked={isChecked}
        size="medium"
        onChange={handlefpChange}
      />

      <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#444" }}>
        Active First Principles
      </Typography>
    </Paper>

    <Box sx={{ display: "flex", flexDirection: "row", border: 0, mt: 1 }}>
      <Box
        component={Paper}
        elevation={0}
        sx={{
          height: 555,
          width: 1710,
          p: 2,
          display: "flex",
          flexDirection: "row",
          gap: 2,
          ...cardStyle,
        }}
      >
        <Box
          sx={{
            position: "relative",
            mt: 1,
            width: 620,
            height: 480,
            p: 2,
            ...cardStyle2,
          }}
        >
          <Box sx={sectionTitleStyle}>Independent Variables</Box>

          <Button
            onClick={() => addfpin()}
            disabled={!props.editAccess}
            sx={{ ...buttonStyle, width: 180, mb: 2 ,mt:2 }}
            variant="contained"
            size="small"
          >
            Add New Independent
          </Button>

          <TableContainer
            component={Paper}
            sx={{ height: 360, ...tableContainerStyle }}
          >
            <Table sx={{ minWidth: 495 }} aria-label="sticky table" stickyHeader>
              <TableHead>
                <TableRow>
                  {["KPI", "Description", "Declaration", "Remark", "Delete"].map((h) => (
                    <TableCell key={h} align="center" sx={headCellStyle}>
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              {getvalues.length
                ? getvalues[0].map((row, i) => (
                    <TableRow
                      key={i}
                      sx={{
                        "&:hover": { bgcolor: "#f8fbff" },
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      {addfprow[0][i] == true ? (
                        <TableCell sx={{ ...bodyCellStyle, width: 50 }} align="center">
                          <FormControl sx={{ width: 100 }} size="small">
                            <OutlinedInput
                              defaultValue={row[0]}
                              onChange={(e) => handleDeclaInp(e, i, "ind_kpi")}
                              sx={inputStyle}
                              size="small"
                            />
                          </FormControl>
                        </TableCell>
                      ) : (
                        <TableCell align="center" sx={bodyCellStyle}>
                          {row[0]}
                        </TableCell>
                      )}

                      {addfprow[0][i] == true ? (
                        <TableCell sx={bodyCellStyle} align="center">
                          <FormControl sx={{ width: 100 }} size="small">
                            <OutlinedInput
                              defaultValue={row[1]}
                              onChange={(e) => handleDeclaInp(e, i, "ind_desc")}
                              sx={inputStyle}
                              size="small"
                            />
                          </FormControl>
                        </TableCell>
                      ) : (
                        <TableCell sx={bodyCellStyle} align="center">
                          {row[1]}
                        </TableCell>
                      )}

                      <TableCell align="center" sx={bodyCellStyle}>
                        <FormControl sx={{ width: 160 }} size="small">
                          <OutlinedInput
                            defaultValue={row[2]}
                            onChange={(e) => handleDeclaInp(e, i, "ind_declaration")}
                            sx={{ ...inputStyle, width: "135px" }}
                            size="small"
                          />
                        </FormControl>
                      </TableCell>

                      <TableCell align="center" sx={bodyCellStyle}>
                        <FormControl sx={{ width: 160 }} size="small">
                          <TextField
                            multiline
                            onChange={(e) => handleDeclaInp(e, i, "ind_remark")}
                            defaultValue={row[3]}
                            rows={2}
                            maxRows={4}
                            sx={inputStyle}
                            size="small"
                          />
                        </FormControl>
                      </TableCell>

                      <TableCell align="center" sx={bodyCellStyle}>
                        <DeleteIcon
                          onClick={addfprow[0][i] == true ? () => deleteSnap(0, i) : undefined}
                          sx={{
                            fontSize: 17,
                            cursor: addfprow[0][i] == true ? "pointer" : "default",
                            color: addfprow[0][i] == true ? Projectcolors.primary : "lightgrey",
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                : fp[0].map((row, i) => (
                    <TableRow
                      key={i}
                      sx={{
                        "&:hover": { bgcolor: "#f8fbff" },
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      {addfprow[0][i] == true ? (
                        <TableCell sx={{ ...bodyCellStyle, width: 50 }} align="center">
                          <FormControl sx={{ width: 100 }} size="small">
                            <OutlinedInput
                              onChange={(e) => handleDeclaInp(e, i, "ind_kpi")}
                              sx={inputStyle}
                              size="small"
                            />
                          </FormControl>
                        </TableCell>
                      ) : (
                        <TableCell align="center" sx={bodyCellStyle}>
                          {row[0]}
                        </TableCell>
                      )}

                      {addfprow[0][i] == true ? (
                        <TableCell sx={bodyCellStyle} align="center">
                          <FormControl sx={{ width: 100 }} size="small">
                            <OutlinedInput
                              onChange={(e) => handleDeclaInp(e, i, "ind_desc")}
                              sx={inputStyle}
                              size="small"
                            />
                          </FormControl>
                        </TableCell>
                      ) : (
                        <TableCell sx={bodyCellStyle} align="center">
                          {row[1]}
                        </TableCell>
                      )}

                      <TableCell align="center" sx={bodyCellStyle}>
                        <FormControl sx={{ width: 160 }} size="small">
                          <OutlinedInput
                            onChange={(e) => handleDeclaInp(e, i, "ind_declaration")}
                            sx={{ ...inputStyle, width: "135px" }}
                            size="small"
                          />
                        </FormControl>
                      </TableCell>

                      <TableCell align="center" sx={bodyCellStyle}>
                        <FormControl sx={{ width: 160 }} size="small">
                          <TextField
                            multiline
                            onChange={(e) => handleDeclaInp(e, i, "ind_remark")}
                            rows={2}
                            maxRows={4}
                            sx={inputStyle}
                            size="small"
                          />
                        </FormControl>
                      </TableCell>

                      <TableCell align="center" sx={bodyCellStyle}>
                        <DeleteIcon
                          onClick={addfprow[0][i] == true ? () => deleteSnap(0, i) : undefined}
                          sx={{
                            fontSize: 17,
                            cursor: addfprow[0][i] == true ? "pointer" : "default",
                            color: addfprow[0][i] == true ? Projectcolors.primary : "lightgrey",
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
            </Table>
          </TableContainer>
        </Box>

        <Box sx={{ height: 390 }}>
          <Box
            sx={{
              width: 355,
              height: 310,
              p: 5,
              textAlign: "center",
              mt: 12,
              mr: 1,
              borderRadius: "24px",
              border: "1px solid #d9e9f7",
              boxShadow: "0 8px 25px rgba(0,120,201,.08)",
              background: "linear-gradient(to bottom,#ffffff,#fbfcff)",
            }}
          >
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 700,
                color: "#0078c9",
              }}
            >
              SelexMB Trained Model
            </Typography>

            <img
              alt="model"
              src={model}
              style={{
                marginTop: 40,
                objectFit: "contain",
                height: "130px",
              }}
            />
          </Box>
        </Box>

        <Box
          sx={{
            position: "relative",
            mt: 1,
            mr: 2,
            width: 660,
            height: 480,
            p: 2,
            ...cardStyle2,
          }}
        >
          <Box sx={sectionTitleStyle}>Dependent Variables</Box>

          <Button
            onClick={() => addfpde()}
            disabled={!props.editAccess}
            sx={{ ...buttonStyle, width: 180, mb: 2 ,mt:2}}
            variant="contained"
            size="small"
          >
            Add New Dependent
          </Button>

          <TableContainer
            component={Paper}
            sx={{ height: 300, ...tableContainerStyle }}
          >
            <Table sx={{ minWidth: 495 }} aria-label="sticky table" stickyHeader>
              <TableHead>
                <TableRow>
                  {["KPI", "Description", "Declaration", "Remark", "Calculations", "Delete"].map((h) => (
                    <TableCell key={h} align="center" sx={headCellStyle}>
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              {(getvalues.length ? getvalues[1] : fp[1]).map((row, i) => (
                <TableRow
                  key={i}
                  sx={{
                    "&:hover": { bgcolor: "#f8fbff" },
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  {addfprow[1][i] == true ? (
                    <TableCell sx={bodyCellStyle} align="center">
                      <FormControl sx={{ width: 100 }} size="small">
                        <OutlinedInput
                          defaultValue={getvalues.length ? row[0] : undefined}
                          onChange={(e) => handleDeclaInp(e, i, "dep_kpi")}
                          sx={inputStyle}
                          size="small"
                        />
                      </FormControl>
                    </TableCell>
                  ) : (
                    <TableCell align="center" sx={bodyCellStyle}>
                      {row[0]}
                    </TableCell>
                  )}

                  {addfprow[1][i] == true ? (
                    <TableCell sx={bodyCellStyle} align="center">
                      <FormControl sx={{ width: 100 }} size="small">
                        <OutlinedInput
                          defaultValue={getvalues.length ? row[1] : undefined}
                          onChange={(e) => handleDeclaInp(e, i, "dep_desc")}
                          sx={inputStyle}
                          size="small"
                        />
                      </FormControl>
                    </TableCell>
                  ) : (
                    <TableCell sx={bodyCellStyle} align="center">
                      {row[1]}
                    </TableCell>
                  )}

                  <TableCell align="center" sx={bodyCellStyle}>
                    <FormControl sx={{ width: 100 }} size="small">
                      <OutlinedInput
                        defaultValue={getvalues.length ? row[2] : undefined}
                        onChange={(e) => handleDeclaInp(e, i, "dep_declaration")}
                        sx={inputStyle}
                        size="small"
                      />
                    </FormControl>
                  </TableCell>

                  <TableCell align="center" sx={bodyCellStyle}>
                    <FormControl sx={{ width: 100 }} size="small">
                      <TextField
                        defaultValue={getvalues.length ? row[3] : undefined}
                        onChange={(e) => handleDeclaInp(e, i, "dep_remark")}
                        multiline
                        rows={2}
                        maxRows={4}
                        sx={inputStyle}
                        size="small"
                      />
                    </FormControl>
                  </TableCell>

                  {addfprow[1][i] == true ? (
                    <TableCell align="center" sx={bodyCellStyle}>
                      <Box sx={{ display: "flex", flexDirection: "row" }}>
                        <Box>
                          <FormControl sx={{ width: 100 }} size="small">
                            <TextField
                              defaultValue={getvalues.length ? row[4] : undefined}
                              onChange={(e) => handleDeclaInp(e, i, "dep_calculations")}
                              multiline
                              rows={3}
                              maxRows={30}
                              sx={inputStyle}
                              value={row[4]}
                              size="small"
                            />
                          </FormControl>
                        </Box>

                        <Box>
                          <IconButton onClick={handleInfoClick}>
                            <InfoIcon fontSize="small" />
                          </IconButton>

                          <IconButton onClick={() => handleMagnifyClick(row[4], i)}>
                            <SearchIcon />
                          </IconButton>

                          <Dialog open={isPopupOpen} onClose={handleClosePopup}>
                            <DialogTitle sx={{ fontSize: "14px", color: Projectcolors.primary }}>
                              First Principle Coding
                            </DialogTitle>

                            <TextField
                              variant="outlined"
                              defaultValue={formula}
                              onChange={(e) =>
                                handleDeclaInp(e, formind, "dep_calculations")
                              }
                              multiline
                              rows={10}
                              maxRows={30}
                              sx={{
                                width: "400px",
                                fontSize: "11px",
                                m: "10px",
                                ...inputStyle,
                              }}
                            />
                          </Dialog>
                        </Box>
                      </Box>
                    </TableCell>
                  ) : (
                    <TableCell align="center" sx={bodyCellStyle}>
                      None
                    </TableCell>
                  )}

                  <TableCell align="center" sx={bodyCellStyle}>
                    <DeleteIcon
                      onClick={addfprow[1][i] == true ? () => deleteSnap(1, i) : undefined}
                      sx={{
                        fontSize: 17,
                        cursor: addfprow[1][i] == true ? "pointer" : "default",
                        color: addfprow[1][i] == true ? Projectcolors.primary : "lightgrey",
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </Table>
          </TableContainer>

          {isLoading ? (
            <Box
              sx={{
                width: "121px",
                height: 40,
                mt: 2,
                mr: 1.5,
                float: "left",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress size={28} sx={{ color: "#0078c9" }} />
            </Box>
          ) : (
            <Button
              onClick={() => savefp()}
              disabled={!props.editAccess}
              sx={{ ...buttonStyle, width: 140, mt: 2, mr: 2, float: "left" }}
              variant="contained"
              size="small"
            >
              Save
            </Button>
          )}

          {saved ? (
            <Alert
              sx={{
                fontSize: "12px",
                color: Projectcolors.primary,
                height: "45px",
                width: "250px",
                mt: 2,
                ml: 5,
                borderRadius: "12px",
              }}
              variant="outlined"
              severity="success"
            >
              First Principles saved
            </Alert>
          ) : (
            <p></p>
          )}
        </Box>
      </Box>
    </Box>

    {getLoader ? <GlobalLoader /> : null}
  </Box>
);
}
